import { emptySplitApi as api } from "./emptyApi"
import type {
  MetricCategory,
  MetricPlatform,
  ChannelType,
  BusinessArea,
  MetricMetadata,
  MetricDictionaryResponse,
} from "~/ui-rtk/constants/metric-dictionary"

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    metricDictionaryControllerGetMetricDictionary: build.query<
      MetricDictionaryControllerGetMetricDictionaryApiResponse,
      MetricDictionaryControllerGetMetricDictionaryApiArg
    >({
      query: queryArg => ({
        url: `/metric-dictionary`,
        params: {
          category: queryArg?.category,
          platform: queryArg?.platform,
          channelType: queryArg?.channelType,
          businessArea: queryArg?.businessArea,
          search: queryArg?.search,
        },
      }),
    }),
    metricDictionaryControllerGetMetricByKey: build.query<
      MetricDictionaryControllerGetMetricByKeyApiResponse,
      MetricDictionaryControllerGetMetricByKeyApiArg
    >({
      query: queryArg => ({ url: `/metric-dictionary/${queryArg.key}` }),
    }),
  }),
  overrideExisting: false,
})

export { injectedRtkApi as generatedApi }

export type MetricDictionaryControllerGetMetricDictionaryApiResponse =
  /** status 200 Returns the list of metrics with their metadata */ MetricDictionaryResponse

export type MetricDictionaryControllerGetMetricDictionaryApiArg = {
  /** Filter by category */
  category?: MetricCategory
  /** Filter by platform */
  platform?: MetricPlatform
  /** Filter by channel type */
  channelType?: ChannelType
  /** Filter by business area */
  businessArea?: BusinessArea
  /** Search by keyword in key, title, or description */
  search?: string
} | void

export type MetricDictionaryControllerGetMetricByKeyApiResponse =
  /** status 200 Returns the metric metadata for the specified key */ MetricMetadata | null

export type MetricDictionaryControllerGetMetricByKeyApiArg = {
  /** The metric key (e.g., facebook_ads_spend) */
  key: string
}

export const {
  useMetricDictionaryControllerGetMetricDictionaryQuery,
  useMetricDictionaryControllerGetMetricByKeyQuery,
} = injectedRtkApi
